
import { AdminApi, AdminUserListItem } from '@/api/AdminApi';
import { GENERIC_ERROR_DESCRIPTION } from '@/constants';
import { AppRoute } from '@/router/routes';
import { PlatformRole, ProjectRole, UserStatus } from 'ignite360-core';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'admin-users',
})
export default class AdminUsers extends Vue {
  readonly PlatformRole = PlatformRole;
  readonly UserStatus = UserStatus;

  isLoading = true;
  filter = '';
  users: AdminUserListItem[] = [];
  impersonatingUserId: string | null = null;

  get filteredUsers(): AdminUserListItem[] {
    const q = this.filter.trim().toLowerCase();
    if (!q) {
      return this.users;
    }
    return this.users.filter((user) => user.email.toLowerCase().includes(q));
  }

  platformRoleLabel(role: PlatformRole): string {
    switch (role) {
      case PlatformRole.SuperAdmin:
        return 'Super Admin';
      case PlatformRole.AccountDirector:
        return 'Account Director';
      case PlatformRole.Member:
        return 'Member';
      default:
        return String(role);
    }
  }

  projectRoleLabel(role: ProjectRole): string {
    switch (role) {
      case ProjectRole.Admin:
        return 'Admin';
      case ProjectRole.Editor:
        return 'Editor';
      case ProjectRole.AccountManager:
        return 'Account Manager';
      case ProjectRole.AnalyticsViewer:
        return 'Analytics Viewer';
      default:
        return String(role);
    }
  }

  async created() {
    this.isLoading = true;
    try {
      this.users = await AdminApi.loadUsers();
    } catch (e) {
      this.$notify.error({
        title: 'Loading users failed',
        description: GENERIC_ERROR_DESCRIPTION,
      });
    } finally {
      this.isLoading = false;
    }
  }

  async handleImpersonate(user: AdminUserListItem) {
    this.impersonatingUserId = user.id;
    try {
      await this.$store.dispatch('auth/impersonate', user.id);
      this.$notify.success(`Now viewing as ${user.email}`);
      await this.$router.replace({ name: AppRoute.Projects });
    } catch (e) {
      this.$notify.error({
        title: 'Impersonation failed',
        description: GENERIC_ERROR_DESCRIPTION,
      });
    } finally {
      this.impersonatingUserId = null;
    }
  }
}
